import loadable from '@loadable/component';

const PlansNative =
  RUNTIME_ENV === 'native'
    ? loadable(() => import('./PlansNative'))
    : () => null;

export { PlansNative };
